import distortVideo from "../../../../src/video/bc-distort-shader.mp4";
import * as React from 'react';
export default {
  distortVideo,
  React
};